/*
 * @author        : chenjiaojiao
 * Created at     : 2022-04-06 10:53:27
 * Last modified  : 2023-12-21 14:38:44
 */
import React, { useEffect, useState } from 'react';
import { Row, Col, Modal } from 'antd';
import s from '../footer/index.module.scss';
import cn from 'classnames';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import LocaleSwitch from 'components/localeSwitch';
import { trackEvent } from 'utils/statics';
import { joinUsUrl, liveTreatyUrl, adminUrl } from 'constants/index';
// import { handleZixunClick } from 'utils/index';
import CustomLink from 'components/link';

function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation('common');
  const [upBtnVisible, setUpBtnVisible] = useState(false);
  const { locale = 'zh-CN' } = useRouter();

  useEffect(() => {
    window.onscroll = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      try {
        requestAnimationFrame(() => {
          setUpBtnVisible(scrollY > 100);
        });
      } catch (error) {
        setUpBtnVisible(scrollY > 100);
      }
    };
  }, []);

  const onScrollTop = () => {
    window.scrollTo(0, 0);
  };

  const onShowEerwei = () => {
    Modal.confirm({
      title: null,
      icon: null,
      content: (
        <div className={s.erweiContainer}>
          <div className={s.erwei}>
            <Image src="/v2/images/footer/wechat-logo.png" alt="wechat-logo" layout="fill" />
          </div>
          <div>{t('nav.saveQRcode')}</div>
          <div className={s.follow}>{t('nav.lookXYlink')}</div>
        </div>
      ),
      className: s.confirmContainer,
      okText: t('nav.sure'),
      cancelText: '',
      okCancel: false,
      width: 'calc(100% - 100px)',
      bodyStyle: { marginTop: 8 },
      centered: true,
      okButtonProps: { className: s.confirmBtn },
    });
  };

  const pcFooterList = [
    {
      title: t('nav.aboutUs'),
      items: [
        { text: t('nav.companyIntroduction'), href: '/about/about' },
        { text: t('nav.companyHonor'), href: '/about/about#honer' },
        { text: t('nav.companyNews'), href: `/news` },
        { text: t('nav.contactUs'), href: '/about/contact' },
        { text: t('nav.joinUs'), href: joinUsUrl, isJump: true },
      ],
    },
    {
      title: t('nav.DownloadCenter'),
      items: [
        { text: t('content.windowsFooter'), href: `/download` },
        { text: t('content.macFooter'), href: `/download` },
        { text: t('content.androidFooter'), href: `/download` },
        { text: t('content.iOSFooter'), href: `/download` },
        { text: t('content.linuxFooter'), href: `/download` },
      ],
    },
    {
      title: t('nav.sales'),
      items: [
        { text: t('nav.productTry'), href: `/try` },
        { text: t('nav.contactSales'), href: `/contact` },
        { text: t('nav.partners'), href: `/partner` },
      ],
    },
    {
      title: t('nav.support'),
      items: [
        { text: t('nav.supportCenter'), href: '/support/faq' },
        { text: t('nav.administrator'), href: adminUrl, isJump: true },
        { text: t('nav.liveConvention'), href: liveTreatyUrl, isJump: true },
        // { text: t('nav.onlineSupport'), href: '', handleClick: handleZixunClick },
      ],
    },
  ];

  const mobileFooterList = [
    [
      { text: t('nav.companyIntroductionEn'), href: '/about/about' },
      { text: t('nav.companyHonorEn'), href: '/about/about#honer' },
      { text: t('nav.contactUs'), href: `/about/contact` },
      { text: t('nav.joinUs'), href: joinUsUrl, isJump: true },
    ],
    [
      { text: t('nav.DownloadCenter'), href: '/download' },
      { text: t('nav.supportCenter'), href: '/support/faq' },
      { text: t('nav.liveConvention'), href: liveTreatyUrl, isJump: true },
      // { text: t('nav.onlineSupport'), href: '', handleClick: handleZixunClick },
    ],
  ];
  return (
    <>
      <div className={s['footer']}>
        <div className={s['footer-container']}>
          <div className={s['footer-row']}>
            <Row justify="center">
              <Col md={{ span: 20 }} lg={{ span: 20 }} xl={{ span: 21 }} xxl={{ span: 16 }} xs={{ span: 24 }}>
                <Row justify="space-around">
                  {pcFooterList.map((colItem, index) => {
                    return (
                      <Col span={6} key={index}>
                        <div className={s['item-group']}>
                          <div className={s['item-title']}>{colItem.title}</div>
                          <ul className={s['item-list']}>
                            {colItem.items.map((item, index) => {
                              return (
                                <li className={s['item']} key={index}>
                                  <CustomLink isNextLink={false} href={item.href} needTarget={item.isJump}>
                                    {item.text}
                                  </CustomLink>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            </Row>
          </div>

          <div className={s['footer-img']}>
            <div className={s['footer-wechat']}>
              <img className={s['footer-weixin']} src="/v2/images/footer/wechat-hover.png" alt="footer-wechat" />
              <div className={s['wechat']}>
                <div className={s['light-pc']}>
                  <div className={s['wechat-img']}>
                    <Image src="/v2/images/footer/wechat-logo.png" alt="xy-wechat" layout="fill" />
                  </div>
                  <p>{t('nav.followUs')}</p>
                </div>
              </div>
            </div>
          </div>

          <p className={s['footer-phone']} style={{ marginTop: '24px' }}>
            <a href="tel:400.900.3567">{t('nav.contactPhone')}</a>
            <span className={s.nemo}>{t('nav.salesSupport')}</span>
          </p>
        </div>
        <div className={cn(s['fixed-r'], s['for-pc'])}>
          <p id="backTotop" className={cn(s['back'], upBtnVisible && s['visible'])} onClick={onScrollTop}>
            <a href="#" className={s['back-to-top']}></a>
          </p>
          <a className={s['call']}>
            <div className={cn(s['call-box'], locale === 'en-US' && '')}>
              <div style={{ display: 'inline-block', marginTop: '10px' }}>
                <span>{t('nav.preSales')}</span>
                <span>{t('nav.preSalesNo')}</span>
              </div>
            </div>
          </a>
          {/* <a className={s['zixun']} onClick={handleZixunClick}>
            <div className={cn(s['box'], locale === 'en-US' && s['en-box'])}>
              <span>{t('nav.preSalesSupport')}</span>
              <span>{t('nav.getQuotes')}</span>
            </div>
          </a> */}
          <a className={s['app-erwei']}>
            <div className={s['box']}>
              <Image src="/v2/images/footer/erwei@2x.png" width="132" height="132" alt="erwei" className={s['erwei-native']} />
              <div className={s.text}>{t('nav.downloadApp')}</div>
            </div>
          </a>
        </div>
      </div>

      <div className={s['mob-only-item']}>
        <div className={cn(s['container-fluid'], s['footer'])}>
          <div className={cn(s['container'], s['item-box'])} id="footer">
            <div className={cn(s['row'], s['link-title'])}>
              {mobileFooterList.map((rowItem, index) => {
                return (
                  <div className={s['character-title']} key={index}>
                    {rowItem.map((item, index) => {
                      return (
                        <div key={index}>
                          <CustomLink isNextLink={false} href={item.href} needTarget={item.isJump}>
                            {item.text}
                          </CustomLink>
                          {index !== rowItem.length - 1 && <span className={s['left-border']}></span>}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>

            <div id="footerWechatIcon" className={s['wechat-img']} onClick={onShowEerwei}>
              <Image src="/v2/images/footer/wechat.png" alt="weixin" layout="fill" />
            </div>

            <div className={s['footer-mask']} id="footerMask">
              <div className={s['light']} id="light">
                <div className={s['two-bar-codes']}>
                  <Image src="/v2/images/footer/wechat-logo.png" alt="wechat-logo" layout="fill" />
                </div>
                <p>{t('nav.saveQRcode')}</p>
                <p>{t('nav.lookXYlink')}</p>
                <div className={s['c-btns']}>
                  <a id="footerConfirmBtn" className={cn(s['btn'], s[' btn-sure'], s['btn-sure'])}>
                    {t('nav.sure')}
                  </a>
                </div>
              </div>
            </div>
            <div className={s['footer-phone']}>
              <p className={s['character-phone']}>
                {t('nav.contactPhone2')}: <a href="tel:400.900.3567">400-900-3567</a>
              </p>
              <p className={s['character-phone']}>{t('nav.salesSupport')}</p>
            </div>
            <LocaleSwitch />
          </div>
        </div>
        <div className={s['fixed-r']}>
          <div className={s['callmobile']}>
            <a onClick={() => trackEvent('callPhone', 'click', 'callMobile')} href="tel:400.900.3567">
              <Image src="/v2/images/footer/call.png" width="60" height="60" alt="call" />
            </a>
          </div>
        </div>
      </div>
      <div className={s['copyright']}>
        Copyright © {currentYear}, XYLink Inc.
        <a href="https://beian.miit.gov.cn/" className={s['icp']} rel="noopener noreferrer" target="_blank">
          沪ICP备17003732号-1
        </a>
        <a className={s['record']} href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502042530" target="_blank" rel="noreferrer">
          <span className={s.emblem}>
            <Image src="/v2/images/footer/national-emblem.png" alt="" layout="fill" />
          </span>
          <span>京公网安备11010502042530号</span>
        </a>
      </div>
    </>
  );
}

export default Footer;
